module.exports = __webpack_public_path__ + "static/media/warning-red.0d65d17e.svg";